import { render, staticRenderFns } from "./PTopHeroSlider.vue?vue&type=template&id=3fdf8774&"
import script from "./PTopHeroSlider.vue?vue&type=script&lang=js&"
export * from "./PTopHeroSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports